// src/components/Profile.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserTickets } from '../api';
import DisplayTickets from './DisplayTickets';

const Profile = () => {
  const [tickets, setTickets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserTickets = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await getUserTickets(token);
        setTickets(response.data);
      } catch (error) {
        console.error('Failed to fetch user tickets:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserTickets();
  }, []);

  return (
    <div className="w-full ">
      <h1 className="text-3xl font-bold text-white mb-6 text-center">Tickets Created By You</h1>
      <DisplayTickets title="Your Tickets" isLoading={isLoading} tickets={tickets} />
    </div>
  );
};

export default Profile;